import { Dispatch } from "redux";

import {
  GET_HRM_SETTINGS_USER_MANUAL,
  UPDATE_HRM_SETTINGS_USER_MANUAL,
} from "./types";

import api from "@helpers/api";
import { UserManualStateAction } from "@reducers/types/HRM/settings/user-manual-state";
import { UserManualType } from "@type/HRM/settings/user-manual";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/user-manual`;

export const fetchUserManual =
  (query: any) => async (dispatch: Dispatch<UserManualStateAction>) => {
    dispatch({ type: GET_HRM_SETTINGS_USER_MANUAL.LOADING, payload: true });

    try {
      const res = await api.get(apiEndPoint, {
        params: query,
      });

      const { data, page, size, total } = res.data || {};

      dispatch({
        type: GET_HRM_SETTINGS_USER_MANUAL.SUCCESS,
        payload: {
          data: data,
          pagination: {
            page: page || 0,
            size: size || 0,
            total: total || 0,
          },
        },
      });
    } catch (err) {
      dispatch({ type: GET_HRM_SETTINGS_USER_MANUAL.ERROR, payload: err });
    }
  };

export const updateUserManual =
  (id: string | number, reqData: UserManualType) =>
  async (dispatch: Dispatch<UserManualStateAction>) => {
    const postUrl = `${apiEndPoint}`;

    const putUrl = `${apiEndPoint}/${id}`;

    const action = id ? "put" : "post";
    const url = id ? putUrl : postUrl;

    dispatch({ type: UPDATE_HRM_SETTINGS_USER_MANUAL.LOADING, payload: true });

    try {
      const res = await api[action](url, {
        ...reqData,
      });

      const { data, page, size, total } = res.data || {};

      dispatch({
        type: UPDATE_HRM_SETTINGS_USER_MANUAL.SUCCESS,
        payload: {
          data,
          pagination: {
            page,
            size,
            total,
          },
        },
      });
    } catch (err) {
      dispatch({ type: UPDATE_HRM_SETTINGS_USER_MANUAL.ERROR, payload: err });
    }
  };

export const deleteUserManual =
  (id: string | number) =>
  async (dispatch: Dispatch<UserManualStateAction>) => {
    dispatch({ type: UPDATE_HRM_SETTINGS_USER_MANUAL.LOADING, payload: true });

    try {
      const res = await api.delete(`${apiEndPoint}/${id}`);

      const { data, page, size, total } = res.data || {};

      dispatch({
        type: UPDATE_HRM_SETTINGS_USER_MANUAL.SUCCESS,
        payload: {
          data: id,
        },
      });
    } catch (err) {
      dispatch({ type: UPDATE_HRM_SETTINGS_USER_MANUAL.ERROR, payload: err });
    }
  };
